import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import LandingPage from "@/pages/LandingPage";
import VisaFinderPage from "@/pages/VisaFinderPage";
import VisaDetailsPage from "@/pages/VisaDetailsPage";
import EVisaPage from "@/pages/EVisaPage";
import OCIPage from "@/pages/OCIPage";
import PCCPage from "@/pages/PCCPage";
import TermsPage from "@/pages/TermsPage";
import AuthPage from "@/pages/AuthPage";

// Components
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App min-h-screen bg-[#F8FAFC] flex flex-col">
      <BrowserRouter>
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/visa-finder" element={<VisaFinderPage />} />
            <Route path="/visa/:countryCode" element={<VisaDetailsPage />} />
            <Route path="/evisa" element={<EVisaPage />} />
            <Route path="/oci" element={<OCIPage />} />
            <Route path="/pcc" element={<PCCPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/auth" element={<AuthPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
